// /src/pages/private/settings/account/accountProfileThemeApi.js

import axios from 'axios';

const BASE = '/api/user/settings/profile-theme';

export async function fetchMyProfileThemeSettings() {
  const { data } = await axios.get(BASE, { withCredentials: true });
  return data;
}

export async function saveMyProfileTheme(themeId) {
  const { data } = await axios.post(
    BASE,
    { themeId },
    { withCredentials: true },
  );
  return data;
}
